const getLocation = state => state.location
const getCoords = state => state.coords
const getLastUpdateTime = state => state.location.timestamp
const getLastUpdateStatus = state => state.lastUpdateStatus
// const getNonReactiveLocation = state => {
//   return JSON.parse(JSON.stringify(state.location))
// }
const getTrackingStatus = state => state.isTracking

export {
  getLocation,
  getCoords,
  // getNonReactiveLocation,
  getLastUpdateStatus,
  getTrackingStatus,
  getLastUpdateTime
}
